<template>
    <h3 style="text-align: left;">Información General</h3>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Fecha de solicitud:<span class="is-invalid">*</span> </label>
        </div>
        <div class="col-md-7">
            <input type="date" class="form-control" id="razon_social" data-date-format="YYYY MM DD" v-model="form.fecha" required />
            <label class="is-invalid">{{validation.fecha}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;"> 
        <div class="col-md-3">
            <label  for="name" >Nombre de proyecto: </label>
        </div>
        <div class="col-md-7"> 
            <input type="text" class="form-control" id="nombre_proyecto" v-model="form.nombre_proyecto" required />
            <label class="is-invalid">{{ !validation.nombre_proyecto || validation.nombre_proyecto === 'null' ? '' : validation.nombre_proyecto }}</label>
            
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3" >
            <label  for="name" >Razón Social:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="razon_social" v-model="form.razon_social" required />
            <label class="is-invalid">{{validation.razon_social}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Nombre del representante de la instalación:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7" >
            <input type="text" class="form-control" id="razon_social" v-model="form.nombre_representante" required />
            <label class="is-invalid">{{validation.nombre_representante}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Email:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7">
            <input type="email" class="form-control" id="email" v-model="form.email" required />
            <label class="is-invalid">{{validation.email}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Inspector:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7">
            
            <select class="form-control" v-model="form.inspector" required>
                <option></option>
                <option :value="datos.name" v-for="datos  in datosinspectores">{{datos.name }}</option>
            </select>
            <label class="is-invalid"></label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Atención a:<span class="is-invalid">*</span> </label>
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="atn" v-model="form.atn" required />
            <label class="is-invalid">{{validation.atn}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Gestionado por:<span class="is-invalid">*</span> </label>  
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="gestionado_por" v-model="form.gestionado_por" required />
            <label class="is-invalid">{{validation.gestionado_por}}</label>
        </div>
    </div>      
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Número de Visitas: </label>
           
        </div>
        <div class="col-md-7">
            <input type="number" class="form-control" id="numero_visitas" v-model="form.numero_visitas" min="0" required />
            <label class="is-invalid"></label>
        </div>
    </div>  
    
            <div class="py-1 row" style="text-align: left;">
                <div class="col-md-3">
                    <label  for="name" >Distancia: </label>
                   
                </div>
                <div class="col-md-7">
                    <input type="number" class="form-control" v-model="form.distancia" min="0" @blur="calcularViaticos"/>
                    <label class="is-invalid"></label>
                </div>
            </div> 
            <div class="py-1 row" style="text-align: left;">
                <div class="col-md-3">
                    <label  for="name" >Viaticos: </label>
                </div>
                <div class="col-md-7">
                    <input type="number" class="form-control" id="viaticos" v-model="form.viaticos" min="0"  @blur="calcularVisitaAdicional" required />
                    <label class="is-invalid"></label>
                </div>
            </div>  
            <div class="py-1 row" style="text-align: left;">
                <div class="col-md-3">
                    <label  for="name" >Costo visita adicional: </label>
                </div>
                <div class="col-md-7">
                    <input type="number" class="form-control" id="visita_adicional"    v-model="form.visita_adicional" readonly  />
                    <label class="is-invalid"></label>
                </div>
            </div>
            <div class="py-1 row" style="text-align: left;">
                <div class="col-md-3">
                    <label  for="name" >Costo total: </label>
                </div>
                <div class="col-md-7">
                    <input type="number" class="form-control" id="costo_total"    v-model="form.costo_total" readonly  />
                    <label class="is-invalid"></label>
                </div>
            </div>
             <div class="py-1 row" style="text-align: left;">
                <div class="col-md-3">
                    <label  for="name" >Otros Gastos: </label>
                   
                </div>
                <div class="col-md-7">
                    <input type="number" class="form-control" v-model="form.otros_gastos" min="0"/>
                    <label class="is-invalid"></label>
                </div>
            </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Tipo: </label>
           
        </div>
        <div class="col-md-7">
            
            <select class="form-control" id="tipo" v-model="form.tipo" required @click="consultarImporte">
                <option value="Generación Distribuida - MT - kW">Generación Distribuida - MT - kW</option>
                        <option value="Centros de Carga Distribución - MT - kW">Centros de Carga Distribución - MT - kW</option>
                        <option value="Centros de Carga Transmisión - AT - MW">Centros de Carga Transmisión - AT - MW</option>
                        <option value="Centrales Eléctricas Distribución - MT - kW">Centrales Eléctricas Distribución - MT - kW</option>
                        <option value="Centrales Eléctricas Transmisión - AT - MW">Centrales Eléctricas Transmisión - AT - MW</option>

            </select>
            <label class="is-invalid"></label>
        </div>
    </div>   
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Dirección:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="direccion" v-model="form.direccion" required />
            <label class="is-invalid">{{validation.direccion}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Capacidad:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="capacidad" v-model="form.capacidad" required @keyup="consultarImporte" />
            <label class="is-invalid">{{validation.capacidad}}</label>
        </div>
    </div>  
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Unidad: </label>
           
        </div>
        <div class="col-md-7">
            
            <select class="form-control" id="unidad" v-model="form.unidad" required>
                <option value="kW">kW</option>
                <option value="MW">MW</option>
               

            </select>
            <label class="is-invalid"></label>
        </div>
    </div>   
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Importe: </label>
           
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="importe" v-model="form.importe" required />
            <label class="is-invalid"></label>
        </div>
    </div>   
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Voltaje de Conexión: </label>
           
        </div>
        <div class="col-md-7">
            
            <select class="form-control" id="voltaje_conexion" v-model="form.voltaje_conexion" required >
                <option value="Alta Tensión">Alta Tensión</option>
                <option value="Media Tensión">Media Tensión</option>
                <option value="Baja Tensión">Baja Tensión</option>
               

            </select>
            <label class="is-invalid"></label>
        </div>
    </div>  
    </hr> 
    <h3 style="text-align: left;">Documentos</h3>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Oficio CFE: </label>
           
        </div>
        <div class="col-md-7">
            <input type="file" @change="onFileChange" accept="application/pdf" class="form-control"/>
            <div v-if="file">
            <h3>Vista previa del archivo:</h3>
            <iframe :src="fileURL" width="100%" height="400"></iframe>
            </div>
            
        </div>
    </div>
    <br>    
    <button type="button" class="btn" style="background-color: #F49315; color: white;">
        <router-link to="/cotizacion" style="color: white;">
            Cancelar
        </router-link>
    </button> &nbsp;
    <button type="button" class="btn" style="background-color: #F49315; color: white;" @click="actualizar">
        Guardar
    </button>
    <br>
</template>

<script>
  import axios from 'axios';
  import "vue3-easy-data-table/dist/style.css";
  import Swal from 'sweetalert2';
  export default {
    data() {
      return {
        
        searchField:[],
        searchValue:[],
        datoscotizaciones:[],
        show: false,
        form: {
          razon_social: '',
          nombre_representante: '',
          email: '',
          inspector: '',
          numero_visitas: '',
          tipo: 'Generación distribuida',
          direccion: '',
          capacidad: '',
          unidad: 'kW',
          importe: '',
          voltaje_conexion: 'Alta Tensión',
          oficio_cfe: '',
          viaticos:0,
            distancia:0,
            costo_total:0,
            otros_gastos:0,
            usuario :localStorage.getItem('name'),
            nombre_proyecto:'',
            atn:'',
            gestionado_por:''
        },
        validation:{
            nombre_proyecto:'',
            razon_social:"",
            nombre_representante:'',
            email:'',
            direccion:'',
            capacidad:'',
            atn:'',
            gestionado_por:''
        },
        headers:[],
        datosinspectores:[],
      };
    },
    created() {
        this.consultarCotizacion();
        this.consultarInspector();
    },
    methods: {
        calcularViaticos() {

            const km = parseFloat(this.form.distancia) || 0;

            let viaticos = 0;

            if (km <= 30) {
                viaticos = 0;
            } else if (km <= 120) {
                viaticos = km * 17;
            } else if (km <= 250) {
                viaticos = km * 19;
            } else if (km <= 400) {
                viaticos = km * 22;
            } else {
                const excedente = km - 400;
                viaticos = (400 * 22) + (excedente * 24);
            }

            this.form.viaticos = viaticos;
            this.form.visita_adicional = (viaticos * 0.70).toFixed(2);



              this.form.viaticos = parseFloat(this.form.viaticos) || 0;
            const numeroVisitas = parseInt(this.form.numero_visitas) || 0;
            const visitasAdicionales = Math.max(0, numeroVisitas - 2);

            const costoVisitasAdicionales = this.form.viaticos * 0.70 * visitasAdicionales;

            this.form.visita_adicional = costoVisitasAdicionales.toFixed(2);
            console.log((viaticos + costoVisitasAdicionales));
            this.form.costo_total = (viaticos + costoVisitasAdicionales);
        },
        calcularVisitaAdicional() {
            const viaticos = parseFloat(this.form.viaticos) || 0;
            const numeroVisitas = parseInt(this.form.numero_visitas) || 0;
            const visitasAdicionales = Math.max(0, numeroVisitas - 2);

            const costoVisitasAdicionales = viaticos * 0.70 * visitasAdicionales;

            this.form.visita_adicional = costoVisitasAdicionales.toFixed(2);
            console.log((viaticos + costoVisitasAdicionales));
            this.form.costo_total = (viaticos + costoVisitasAdicionales);
        },
        consultarInspector(){
        const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };
       
            axios.get(this.$rutaServer+'inspectores',config).then(response => {
                this.datosinspectores = response.data.data;
            })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
      },
        consultarCotizacion(){
            var idcotizacion = localStorage.getItem('idcotizacion');
            axios.post(this.$rutaServer+'datosCotizacion', { id: idcotizacion })
          .then(response => {
            if (response.status == 200) {
                const nombreProyecto = response.data.data[0].nombre_proyecto;
                this.form.nombre_proyecto = nombreProyecto == null || nombreProyecto === 'null' ? '' : nombreProyecto;

                this.datoscotizaciones = response.data.data[0];
                this.form.nombre_representante = response.data.data[0].nombre_representante;
                this.form.fecha = response.data.data[0].fecha;
                this.form.razon_social = response.data.data[0].razon_social;
                this.form.email = response.data.data[0].email;
                this.form.inspector = response.data.data[0].inspector;
                //this.form.nombre_proyecto = response.data.data[0].nombre_proyecto || '';
                this.form.capacidad = response.data.data[0].capacidad;
                this.form.direccion = response.data.data[0].direccion;
                this.form.importe = response.data.data[0].importe;
                this.form.numero_visitas = response.data.data[0].numero_visitas;
                this.form.tipo = response.data.data[0].tipo;
                this.form.unidad = response.data.data[0].unidad;
                this.form.usuario = response.data.data[0].usuario;
                this.form.viaticos = response.data.data[0].viaticos;
                this.form.visita_adicional = response.data.data[0].visita_adicional;
                this.form.distancia = response.data.data[0].distancia;
                this.form.otros_gastos = response.data.data[0].otros_gastos;
                this.form.costo_total = response.data.data[0].costo_total;
                this.form.atn = response.data.data[0].atn;
                this.form.gestionado_por = response.data.data[0].gestionado_por;
                this.form.fecha = response.data.data[0].fecha;
                this.form.voltaje_conexion = response.data.data[0].voltaje_conexion;
                console.log(this.form.fecha);
            }
          })
          .catch(error => {
            Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
        },
        actualizar(){
            var idcotizacion = localStorage.getItem('idcotizacion');
            const formData = new FormData();
            if (!this.form.inspector) {
                Swal.fire('¡Error!', 'Debe seleccionar un inspector.', 'error');
                return;
            }
            if (!this.form.fecha) {
                Swal.fire('¡Error!', 'Debe seleccionar fecha.', 'error');
                return;
            }
            if (!this.form.atn) {
                    Swal.fire('¡Error!', 'Debe llenar el campo Atención a.', 'error');
                    return;
            }
            if (!this.form.gestionado_por) {
                    Swal.fire('¡Error!', 'Debe llenar el campo Gestionado por.', 'error');
                    return;
            }
            //formData.append('pdf', this.file);
            //formData.append('folio', this.form.folio);
            formData.append('fecha', this.form.fecha);
            formData.append('cie', this.form.cie);
            formData.append('nombre_proyecto', this.form.nombre_proyecto);
            formData.append('razon_social', this.form.razon_social);
            formData.append('nombre_representante', this.form.nombre_representante);
            formData.append('email', this.form.email);
            formData.append('inspector', this.form.inspector);
            formData.append('numero_visitas', this.form.numero_visitas);
            formData.append('tipo', this.form.tipo);
            formData.append('direccion', this.form.direccion);
            formData.append('capacidad', this.form.capacidad);
            formData.append('unidad', this.form.unidad);
            formData.append('importe', this.form.importe);
            formData.append('voltaje_conexion', this.form.voltaje_conexion);
            formData.append('oficio_cfe', this.form.oficio_cfe);
            formData.append('usuario', localStorage.getItem('email'));
            formData.append('idcotizacion', idcotizacion);
            formData.append('visita_adicional', this.form.visita_adicional);
            formData.append('viaticos', this.form.viaticos);
            formData.append('distancia', this.form.distancia);
            formData.append('otros_gastos', this.form.otros_gastos);
            formData.append('costo_total', this.form.costo_total);
            formData.append('atn', this.form.atn);
            formData.append('gestionado_por', this.form.gestionado_por);
            formData.append('fecha', this.form.fecha);

            
            axios.post('https://backsarei.seguridadeninspeccion.com/api/actualizarcotizacion',  formData ).then(response => {
            //axios.post('http://127.0.0.1:8000/api/actualizarcotizacion',  formData ).then(response => {
           
            if (response.status == 200) {
                Swal.fire('Exito!', 'Se actualizo con exito la cotización', 'success');
                this.consultarCotizacion();
            }
          })
          .catch(error => {
            Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
        },
        consultarImporte(){
        //this.loading = true;
        //axios.post('https://backsarei.seguridadeninspeccion.com/api/consultarCotizaciones')
       
        if(this.form.tipo > ' ' && this.form.capacidad){
            console.log(this.form.tipo);
            console.log(this.form.capacidad);
            axios.post(this.$rutaServer+'calcular',{cantidad:this.form.capacidad,descripcion:this.form.tipo})

            .then(response => {
                //console.log(response.data);
                if(response.status == 200){
                    this.form.importe = response.data.importe;
                    this.form.importeFor = Number(response.data.importe).toLocaleString('es-MX', {
                        style: 'currency',
                        currency: 'MXN'
                    });
                    this.form.unidad = response.data.unidad;
                    //this.loading = false;
                }
                
                
            })
            .catch(error => {
                console.error('Error submitting form:', error);
            
            });
        }
      }
    },
}
</script>
<style>
.is-invalid {
    color: red;
}
</style>